import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React, { useContext, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { MattressBuilderContext } from "./MattressBuilderContext";

import BedSizes from "./BedSizes";

import EvrbedSwitch from "../../../components/Switch/EvrbedSwitch";

import GeneralStepsHeader from "./GeneralStepsHeader";
import HeaderQuestion from "./HeaderQuestion";
import NextButton from "./NextButton";

import {
  createCustomer,
  customerEmailAddressSelector,
  customerEmailNotFoundSelector,
  metaFieldIdSelector,
  shopifyCustomerSelector,
} from "../../../redux/slices/customer";
import { getAdaptiveFontSize } from "../../../utils/styling.utils";
import {
  getMattressConfigurationFromLocalStorage,
  saveMattressConfigurationToLocalStorage,
} from "../../../utils/bedBuilder.utils";
import {
  initialState,
  isSingleSleeperSelector,
  mattressConfigurationSelector,
  setIsSingleSleeper,
  setMattressGlobalState,
  updateMattressConfiguration,
} from "../../../redux/slices/mattressConfiguration";
import { setCurrentStepGeneral } from "../../../redux/slices/customNavigation";

import ArrowRightAltTwoToneIcon from "@mui/icons-material/ArrowRightAltTwoTone";
import styled from "styled-components";
import useMediaQuery from "@mui/material/useMediaQuery";
import ReactGA from "react-ga";

const StyledBedSizeSelectorContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 95%;
  overflow: auto;
`;

const StyledHeaderQuestionContainer = styled.div`
  margin-top: 1px;
  margin-bottom: 0vh;
`;

const StyledBedSizesContainer = styled.div`
  //margin-top: 2rem;
`;

const StyledNextButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  height: 15vh;
  width: 100%;
  position: relative;
  flex: 1 1 auto;
  bottom: 0;
`;

const BedSizeSelector = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  //Media Queries
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };
  const bedSize = useSelector(
    state => state.mattressConfiguration.mattressConfiguration.bedSize
  );
  const emailNotFound = useSelector(customerEmailNotFoundSelector);
  // // console.log("=>(filename:70) emailNotFound", emailNotFound);
  const emailAddress = useSelector(customerEmailAddressSelector);
  // // console.log("=>(BedSizeSelector.js:86) emailAddress", emailAddress);

  useEffect(() => {
    if (emailNotFound) {
      let initialMattressConfiguration = {
        ...initialState,
        cart: undefined,
        loading: undefined,
      };

      dispatch(
        createCustomer({
          email: emailAddress,
          mattressConfiguration: initialMattressConfiguration,
        })
      );
    }
  }, [emailNotFound]);

  useEffect(() => {
    //Check Local Storage
    // // console.log('ping');
    // const localStorageMattressConfiguration = getMattressConfigurationFromLocalStorage();
    // if (localStorageMattressConfiguration !== null) {
    //   dispatch(
    //     setMattressGlobalState(JSON.parse(localStorageMattressConfiguration))
    //   );
    // }
  }, []);

  let localIsSingleSleeper = true;
  const shopifyCustomer = useSelector(shopifyCustomerSelector);
  const metaFieldId = useSelector(metaFieldIdSelector);
  const mattressConfiguration = useSelector(mattressConfigurationSelector);
  const newMattressConfiguration = useSelector(state => state);
  // // console.log("NEW NEW newMattressConfiguration", newMattressConfiguration);

  const handleUpdateMattressConfiguration = () => {
    //Update in local storage
    // console.log("saving to local storage");
    saveMattressConfigurationToLocalStorage(mattressConfiguration);

    //Update in Shopify
    const newMattressConfiguration = {
      metaFieldId: metaFieldId,
      id: shopifyCustomer.id,
      mattressConfiguration: mattressConfiguration,
    };
    dispatch(updateMattressConfiguration(newMattressConfiguration));
  };

  ReactGA.pageview('/mattress-builder/mattress-size-selector');
  return (
    <StyledBedSizeSelectorContainer className="m-4">
      <GeneralStepsHeader></GeneralStepsHeader>
      <EvrbedSwitch
        checked={!isSingleSleeper}
        labelLeft={t("1 Sleeper")}
        labelRight={t("2 Sleepers")}
        onChange={(event) => { dispatch(setIsSingleSleeper(event.target.checked)); }}
        value={!isSingleSleeper}
      ></EvrbedSwitch>
      <StyledHeaderQuestionContainer>
        <HeaderQuestion
          styles={{
            width: "65%",
            fontSize: getAdaptiveFontSize({
              screenWidthHooks,
              fontSize: 1.15,
            }),
          }}
        >
          {t("What Size Of Bed Would You Like To Personalize?")}
        </HeaderQuestion>
      </StyledHeaderQuestionContainer>
      <StyledBedSizesContainer>
        <BedSizes/>
      </StyledBedSizesContainer>
      <StyledNextButtonContainer>
        <NextButton
          disabled={bedSize === ""}
          styles={{ marginBottom: "3vh", marginRight: "4vw" }}
          iconComponent={() => (
            <ArrowRightAltTwoToneIcon></ArrowRightAltTwoToneIcon>
          )}
          onClick={() => {
            // ReactGA.event({
            //   category: 'User',
            //   action: 'Selected Mattress Size',
            //   label: JSON.stringify(mattressConfiguration)
            // });
            ReactGA.pageview('/mattress-builder/partner-name-entry');
            handleUpdateMattressConfiguration();
            dispatch(setCurrentStepGeneral(1));
          }}
          className="col-12"
        ></NextButton>
      </StyledNextButtonContainer>
    </StyledBedSizeSelectorContainer>
  );
};

export default BedSizeSelector;
